import { shallowEqual, useSelector } from 'react-redux';

import { FeatureToggleProvider } from 'src/app/shared/featureToggle';
import { getEnvironment } from 'src/app/utils/environment';
import type { AppState } from 'src/types/appState';

export const FeatureToggleProviderV1 = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // WARNING: input has potential to become dumping ground of store attributes.
  const input = useSelector(
    (state: AppState) => ({
      advertiserId: state.session.seekAdvertiserId,
      env: getEnvironment(),
      flowType: state.formData.flowType,
      hirerAccount: state.session.hirerAccount,
      productFeatures: state.session.productFeatures,
      currentPage: state.session.pageId,
    }),
    shallowEqual,
  );

  return <FeatureToggleProvider {...input}>{children}</FeatureToggleProvider>;
};
